import { sendDataDogEvent } from './datadog/events';
import { logger } from './datadog/logger';
import { RumEventContext } from './datadog/types';
import { sendFullStoryEvent } from './fullstory/events';
import { recordJourneyStepsForTrackingEvent } from './journey/trackingEventSteps';
import { TrackingEvents } from './trackingEvents';

export { TrackingEvents };

/**
 * Send logging events to FullStory and DataDog. Optionally, log to Datadog.
 */
export function sendLoggingEvents(
  eventName: TrackingEvents,
  eventProperties?: object,
  { logLevel, message, error }: { logLevel?: keyof typeof logger; message?: string; error?: Error } = {},
) {
  sendFullStoryEvent(eventName, eventProperties);
  // FIXME: TREE-200 Handle nested objects
  sendDataDogEvent(eventName, eventProperties as RumEventContext);
  try {
    recordJourneyStepsForTrackingEvent(eventName, eventProperties as Record<string, unknown> | undefined, {
      isError: logLevel === 'error' || !!error,
    });
  } catch (journeyError) {
    logger.warn('Unable to record journey step', { eventName }, journeyError as Error);
  }
  if (!logLevel) return;
  logger[logLevel](message ?? eventName, { ...eventProperties, eventName }, ...(error ? [error] : []));
}
